<div class="banner" [class.banner--search-expanded]="showResults">
  <div class="banner__media">
    <video #bannerVideo class="banner--video" autoplay muted loop playsinline preload="auto">
      <source src="/banner.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </div>

  <!-- Search Overlay -->
  <div class="search--overlay" *ngIf="showResults" (click)="closeResults()"></div>

  <!-- Hero Content Wrapper (has-search-open raises z-index above overlay on mobile/tablet so result clicks work) -->
  <div class="hero--content-wrapper" [class.has-search-open]="showResults">
    <div class="hero--content">
      <h1 class="hero--title">
        Maharashtra’s Gateway to Data-Driven Farming: <span class="hero--title-highlight"> Empowering Agriculture
          Ecosystem </span>
      </h1>

      <p class="hero--description">
        MahaAgX is a platform that helps revolutionise agriculture<br />
        through a secure data exchange network for researchers,<br />
        innovators, and policymakers.
      </p>

      <div class="hero--search-container" [class.has-results]="showResults">
        <div class="hero--search">
          <input type="text" class="search--input" placeholder="Search for Datasets and Models..."
            [(ngModel)]="searchQuery" (input)="onSearchInput()" (focus)="onInputFocus()" (keyup.enter)="onSearch()" />
          <button class="search--button" aria-label="Search" (click)="onSearch()">
            <svg *ngIf="!isLoading" viewBox="0 0 24 24" width="24" height="24">
              <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="2" fill="none" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" stroke="currentColor" stroke-width="2" />
            </svg>
            <span *ngIf="isLoading" class="search--spinner"></span>
          </button>
        </div>

        <!-- Search Results Dropdown -->
        <div class="search--results" *ngIf="showResults && visibleResultsCount > 0">
          <!-- Datasets Section -->
          <div class="results--section" *ngIf="groupedResults.datasets.length > 0">
            <div class="section--header">
              <div class="section--header-left">
                <img src="/asset-dataBank.svg" alt="Dataset" class="section--icon" />
                <span class="section--title">Datasets</span>
                <span class="section--count">{{ groupedResults.datasets.length }}</span>
              </div>
              <button class="section--view-all" (click)="viewAllResults('datasets')"
                *ngIf="groupedResults.datasets.length > 2">
                View All
              </button>
            </div>
            <div class="search--result-item" *ngFor="let result of groupedResults.datasets.slice(0, 2)"
              (click)="navigateToAsset(result)">
              <div class="result--content">
                <div class="result--header">
                  <span class="result--label">{{ result.label }}</span>
                </div>
                <div class="result--name" *ngIf="result.name && result.name !== result.label">
                  {{ result.name }}
                </div>
              </div>
              <svg class="result--arrow" viewBox="0 0 24 24" width="20" height="20">
                <polyline points="9 18 15 12 9 6" stroke="currentColor" stroke-width="2" fill="none" />
              </svg>
            </div>
          </div>

          <!-- Models Section -->
          <div class="results--section" *ngIf="groupedResults.models.length > 0">
            <div class="section--header">
              <div class="section--header-left">
                <img src="/asset-ai-model.svg" alt="Model" class="section--icon" />
                <span class="section--title">Models</span>
                <span class="section--count">{{ groupedResults.models.length }}</span>
              </div>
              <button class="section--view-all" (click)="viewAllResults('models')"
                *ngIf="groupedResults.models.length > 2">
                View All
              </button>
            </div>
            <div class="search--result-item" *ngFor="let result of groupedResults.models.slice(0, 2)"
              (click)="navigateToAsset(result)">
              <div class="result--content">
                <div class="result--header">
                  <span class="result--label">{{ result.label }}</span>
                </div>
              </div>
              <svg class="result--arrow" viewBox="0 0 24 24" width="20" height="20">
                <polyline points="9 18 15 12 9 6" stroke="currentColor" stroke-width="2" fill="none" />
              </svg>
            </div>
          </div>

        </div>

        <!-- No Results Message -->
        <div class="search--results search--no-results"
          *ngIf="showResults && visibleResultsCount === 0 && !isLoading && searchQuery.trim().length >= 3">
          <div class="no-results--message">
            <span>No results found.</span>
          </div>
        </div>
      </div>

      <button class="scroll--down" aria-label="Scroll down" (click)="scrollToStatistics()">
        <svg viewBox="0 0 24 24" width="24" height="24">
          <polyline points="6 9 12 15 18 9" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>
      </button>
    </div>
  </div>
</div>